import { render, staticRenderFns } from "./CreateTicketAgent.vue?vue&type=template&id=39848671&"
import script from "./CreateTicketAgent.vue?vue&type=script&lang=js&"
export * from "./CreateTicketAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports